const Projects = [
    {
        title: 'Solar Digital',
        img: require('../img/thumbnails/solar_digital_tn.png'),
        type: 'Course Project (CS230 Deep Learning)',
        desc: 'Built a image classification and segmentation model using ResNet-30 for solar panel detection from satellite imagery.',
        skills: 'TensorFlow, Keras, Jupyter Notebooks'
    },
    {
        title: 'Recipal',
        img: require('../img/thumbnails/recipal_tn.png'),
        type: 'Course Project (CS147 Intro to HCI)',
        desc: 'Designed and developed a high-fidelity prototype for a recipe personalization mobile application.',
        skills: 'React Native, CSS, Figma'
    },
    {
        title: 'Bare Metal PC Shell',
        img: require('../img/thumbnails/bare_tn.png'),
        type: 'Course Project (CS107E Computer Systems from the Ground Up)',
        desc: 'Constructed working Unix-based console using the Raspberry Pi\'s ARM architecture.',
        skills: 'C, Raspberry Pi'
    },
    {
        title: 'Inseciticides alter seasonal adaptation in Drosophila',
        img: require('../img/thumbnails/petrov_tn.png'),
        type: 'Evolution Researcher @ Stanford Petrov Lab',
        desc: 'Investigated whether the evolution of insecticide resistance interacts with the seasonal evolution of pigmentation.',
        // skills: 'C, Raspberry Pi'
    },
    {
        title: 'Climate drives Ross River and Barmah Forest Virus',
        img: require('../img/thumbnails/mordecai_tn.png'),
        type: 'Ecology Researcher @ Stanford Mordecai Lab',
        desc: 'Investigated the extent min/max temperature and precipitation correlates with RRV and BFV incidence in Queensland, Australia.',
        // skills: 'C, Raspberry Pi'
    },
    {
        title: 'Molecule halts pancreatic beta cell function',
        img: require('../img/thumbnails/cobb_tn.png'),
        type: 'Pharmacology Researcher @ UTSW Cobb Lab',
        desc: 'Investigated mechanisms (insulin secretion, metabolism, calcium influx, and gene expression) of 7 beta cell inhibitors.',
        // skills: 'C, Raspberry Pi'
    },
    {
        title: 'The Stanford Daily',
        img: require('../img/thumbnails/daily_tn.png'),
        type: 'Managing Editor of Photo & Video',
        desc: 'Delegated responsibilities for 50+ photo/video staffers and oversaw timelines for 30+ multimedia projects for YouTube and social media platforms',
        // skills: 'C, Raspberry Pi'
    },
    {
        title: 'High School Support Initiative',
        img: require('../img/thumbnails/hssi_tn.png'),
        type: 'Education Partnerships Fellow',
        desc: 'Trained tutor-mentor team and collaborated with community partners to provide academic and social-emotional enrichment for low-income youth.',
        // skills: 'C, Raspberry Pi'
    },
    {
        title: 'Wildlife Photography',
        img: require('../img/thumbnails/wildlife_tn.png'),
        type: 'Personal Project',
        desc: 'Discovering and capturing beautiful fauna, especially birds and reptiles.',
        // skills: 'C, Raspberry Pi'
    },
]

export default Projects;